/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Register_Onboarding_Personal_Info_Soft_Skills_TitleInputs */

const en_register_onboarding_personal_info_soft_skills_title = /** @type {(inputs: Register_Onboarding_Personal_Info_Soft_Skills_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soft skills (max. ${i?.max})`)
};

const de_register_onboarding_personal_info_soft_skills_title = /** @type {(inputs: Register_Onboarding_Personal_Info_Soft_Skills_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soft Skills (max. ${i?.max})`)
};

/**
* | output |
* | --- |
* | "Soft skills (max. {max})" |
*
* @param {Register_Onboarding_Personal_Info_Soft_Skills_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_soft_skills_title = /** @type {((inputs: Register_Onboarding_Personal_Info_Soft_Skills_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Soft_Skills_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_soft_skills_title(inputs)
	return en_register_onboarding_personal_info_soft_skills_title(inputs)
});